const ADDRESS_PROVIDERS = {
  UNKNOWN: 1,
  QAS: 2,
  GB_GROUP: 3,
  MANUAL_ADDRESS_ENTRY: 4
};

export default ADDRESS_PROVIDERS;
